<template>
	<section class="gallery-slider">
		<div class="slide-row">
			<div ref="emblaCarousel" class="embla">
				<div class="embla__container">
					<div v-for="item in items" :key="item.ID" class="slick-item embla__slide">
						<picture>
							<source v-if="item.imageWebp" :srcset="item.imageWebp" type="image/webp" />
							<source :srcset="item.image" />
							<img loading="lazy" :src="item.image" :alt="item.imageAlt" />
						</picture>
					</div>
				</div>

				<div class="embla-controls">
					<div class="button-prev" @click="prevSlide">
						<font-awesome-icon icon="far fa-arrow-left-long" size="1x" />
					</div>
					<div class="button-next" @click="nextSlide">
						<font-awesome-icon icon="far fa-arrow-right-long" size="1x" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';
import Autoplay from 'embla-carousel-autoplay';

defineProps({
	items: { type: Array, default: () => [] },
});

const [emblaCarousel, emblaApi] = emblaCarouselVue({ loop: true, duration: 20 }, [Autoplay({ delay: 8000 })]);
const selectedScrollSnap = ref(0);

function prevSlide() {
	emblaApi.value.scrollPrev();
}

function nextSlide() {
	emblaApi.value.scrollNext();
}

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.gallery-slider {
	padding: 20px 0;
	border-top: 1px solid var(--contentblock-background-color);
	border-bottom: 1px solid var(--contentblock-background-color);
}

.embla {
	overflow: hidden;
	position: relative;

	&::before,
	&::after {
		content: '';
		display: block;
		background: linear-gradient(90deg, rgb(238 231 228 / 0%) 0%, #eee7e4 100%);
		opacity: 0.8;
		position: absolute;
		inset: 0 0 0 auto;
		width: 15vw;
		z-index: 2;
	}

	&::before {
		inset: 0 auto 0 0;
		background: linear-gradient(270deg, rgb(238 231 228 / 0%) 0%, #eee7e4 100%);
	}
}

/* stylelint-disable */
.embla__container {
	display: flex;
}

.embla__slide {
	flex: 0 0 40%;
	min-width: 0;
}
/* stylelint-enable */

.embla-controls {
	div {
		width: 60px;
		height: 60px;
		cursor: pointer;
		text-align: center;
		line-height: 70px;
		position: absolute;
		top: calc(50% - 30px);
		left: 2%;
		z-index: 10;

		&.button-next {
			left: auto;
			right: 2%;
		}

		svg {
			font-size: 32px;
			color: var(--primary-background-color);
		}
	}
}

/* stylelint-disable */
@media (max-width: 1080px) {
	.embla__slide {
		flex: 0 0 66%;
	}
}

@media (max-width: 880px) {
	.embla__slide {
		flex: 0 0 75%;
	}

	.embla {
		&::before,
		&::after {
			width: 12vw;
		}
	}
}

@media (max-width: 680px) {
	.embla__slide {
		flex: 0 0 80%;
	}
}
/* stylelint-enable */
</style>
